
<div class="analog__clock">
  <div class="analog__clock__hour hand" #hourHand></div>
  <div class="analog__clock__minute hand" #minuteHand></div>
</div>

<div class="digital__clock">
  <div class="digital__clock__container">
    <strong class="h3 digital__clock__time">{{ time }}</strong>
    <span class="digital__clock__moment">{{ moment }}</span>
  </div>
  <em class="digital__clock__location">{{ location }}</em>
</div>
